import styled from 'styled-components';
import React from 'react';
import { TopContent } from './TopContent';
import { MiddleContent } from './MiddleContent';
import { BottomContent } from './BottomContent';
import { rem } from '@mantine/core';

interface Props {
	className?: string;
	children: React.ReactNode;
}

const DashCard = ({ className, children }: Props) => {
	const childrenArray = React.Children.toArray(children);

	return (
		<div className={`${className}`}>
			{childrenArray.map((child) => {
				if (React.isValidElement(child)) {
					return child;
				}
				return null;
			})}
		</div>
	);
};

DashCard.Top = TopContent;
DashCard.Middle = MiddleContent;
DashCard.Bottom = BottomContent;
DashCard.Divider = () => <StyledDivider />;

const StyledDivider = styled.div`
	width: 100%;
	height: ${rem(2)};
	background-color: ${({ theme }) => theme.v2.color.neutral[900]};
`;

const BottomWrapper = styled.div``;

const Styled = styled(DashCard)`
	box-sizing: border-box;
	flex-grow: 0;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: stretch;
	gap: ${rem(8)};
	padding: ${rem(8)};
	border-radius: ${rem(8)};
	background-color: ${({ theme }) => theme.v2.color.neutral[1200]};
	${BottomWrapper} {
		margin-top: auto;
	}
	min-height: ${rem(80)};
`;

export { Styled as DashCard };
